<template>
  <span :class="`article-tag-wrapper ${tagColor}`"><slot /></span>
</template>

<script>
export default {
  name: 'ArticleTag',
  props: {
    /**
     * タグカラー
     * pink or blue or orange
     */
    tagColor: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="sass" scoped>
.article-tag-wrapper
  line-height: 18px
  border-radius: 10px
  color: $color-text-tag
  font: $font-tag
  padding: 3px 5px
  &.pink
    background-color: $color-background-tag-pink
  &.blue
    background-color: $color-background-tag-blue
  &.orange
    background-color: $color-background-tag-orange
</style>
